// extracted by mini-css-extract-plugin
export default {"card":"styles_card__hzPiV","imageContainer":"styles_imageContainer__-GjWF","image":"styles_image__z5K+q"};